import { requestContextForTenantItems, type StitchRequestConfig } from '@modules/common/services/base-stitch.service';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@environment';
import { type Observable } from 'rxjs';

@Injectable()
export class EventInviteService {
  private readonly http = inject(HttpClient);

  /** The route answers an empty object once sending is initiated; the mails go out asynchronously. */
  public sendInvites(eventId: string, config?: StitchRequestConfig): Observable<Record<string, never>> {
    return this.http.post<Record<string, never>>(
      `${environment.baseUrl}/api/calendar/events/${eventId}/invite/send`,
      {},
      { context: requestContextForTenantItems([], config) },
    );
  }
}
